export default __webpack_public_path__ + "static/media/Login_old.f8961193.jpeg";